export const sort = (property, asc) => (a, b) => {
  const valA = typeof a[property] === 'string' ? a[property].toLowerCase() : a[property]
  const valB = typeof b[property] === 'string' ? b[property].toLowerCase() : b[property]

  if (valA < valB) {
    return asc ? -1 : 1
  }
  if (valA > valB) {
    return asc ? 1 : -1
  }
  return 0
}
